import * as angular from 'angular';
import { config, reactShell } from 'angular/utils/config';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ShipperResource } from '../_resources/shipper.resource';

class ShippersDetailsComponentCtrl implements ng.IController {
    public customerRefId: number;
    public assignment: TsoShipperAssignmentsDto;
    public errorLoading: boolean;
    public subPage: string;
    public showContracts = false;
    public showFinancialSecurities = false;
    public fsLoading = false;
    public appBaseUrl = config.appBaseUrl;

    constructor(
        private Shipper: ShipperResource,
        private TransmissionSystemOperator: any,
        private errorHandler: ErrorHandler,
        private authService: AuthService,
        private $location: any
    ) {}

    async $onInit() {
        let loggedInUser = this.authService.getLoggedInUser();

        if (config.contractManagement) {
            try {
                const response = await reactShell.axios.request({
                    url: config.contractManagement
                });
                this.showContracts = Boolean(
                    response.data &&
                        response.data._links &&
                        response.data._links.contracts
                );
                if (response.data._links.shipper) {
                    this.checkFinancialSecurities(
                        response.data._links.shipper.href
                    );
                }
            } catch (err) {
                // just keep contracts hidden for now
            }
        }

        this.loadShipperAssignment();
        if (!this.subPage) {
            this.subPage = 'documents';
        }
    }

    public isActive(path: string) {
        return this.$location.path().startsWith(path);
    }

    public checkFinancialSecurities(shipperLink: string) {
        this.fsLoading = true;
        this.Shipper.get({ id: this.customerRefId })
            .$promise.then(async ({ organizationId }) => {
                try {
                    const response = await reactShell.axios.request({
                        url: shipperLink.replace('{shipperId}', organizationId)
                    });
                    this.showFinancialSecurities = Boolean(
                        response.data &&
                            response.data._links &&
                            response.data._links.getFinancialSecurities
                    );
                } catch (err) {}
            })
            .finally(() => {
                this.fsLoading = false;
            });
    }

    public loadShipperAssignment() {
        let params = { customerRefId: this.customerRefId };

        this.TransmissionSystemOperator.assignedShipperForId(
            params,
            (res) => {
                this.assignment = res;
            },
            (err: any) => {
                this.errorLoading = true;
                this.errorHandler(err);
            }
        );
    }

    public parentCallback(reload: boolean) {
        if (reload) {
            this.loadShipperAssignment();
        }
    }
}

angular.module('app').component('pkpShippersDetails', {
    controller: ShippersDetailsComponentCtrl,
    template: require('app/shippers/shippers-details.component.html'),
    bindings: {
        customerRefId: '<',
        subPage: '<'
    }
});
